import { Icon } from '@iconify/react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { alpha } from '@mui/material/styles';
import { validateProps } from '../../../../utils/propValidator';

const propRules = {
  id: { type: 'string', required: true },
  value: { type: 'string', required: true },
  options: {
    type: 'array',
    required: true,
    items: {
      type: 'object',
      shape: {
        value: { type: 'string', required: true },
        label: { type: 'string', required: true },
      },
    },
  },
  onChange: { type: 'function', required: true },
};

function ChevronDownIcon(props) {
  return <Icon icon='ri:arrow-drop-down-line' width={24} {...props} />;
}

export default function DropdownBtn(props: any) {
  validateProps(props as Record<string, unknown>, propRules, 'DropdownBtn');

  const { id, value, options = [], onChange, disabled = false } = props;

  return (
    <Select
      id={id}
      name={id}
      size='small'
      value={value}
      onChange={onChange}
      disabled={disabled}
      IconComponent={ChevronDownIcon}
      sx={{
        minWidth: 100,
        '& .MuiSelect-select': {
          color: (theme) => alpha(theme.palette.primary.light, 0.6),
          fontWeight: 500,
          fontSize: '0.875rem',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: '2px solid',
          borderColor: (theme) => alpha(theme.palette.primary.light, 0.4),
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '2px solid',
          borderColor: (theme) => alpha(theme.palette.primary.light, 0.4),
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: (theme) => alpha(theme.palette.primary.light, 0.4),
        },
        '& .MuiSelect-iconOutlined': {
          marginTop: '-5px',
          color: (theme) => alpha(theme.palette.primary.light, 0.6),
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}
